import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import type { GetPoliciesResponse } from '@/api/policies/get-policies'

export const mockGetPolicies = http.get(
  '/my-business/api/agency/v1/*/:companyAlphaId/policies',
  () => {
    const data: GetPoliciesResponse[] = Array.from({ length: 10 }).map(
      (_, index) => ({
        active: faker.datatype.boolean({ probability: 0.9 }),
        alphaId: index === 0 ? 'uuid' : faker.string.uuid(),
        code: Number(faker.string.numeric(4)),
        companyId: Number(faker.string.numeric(4)),
        created: faker.date.recent().toISOString(),
        current: index === 0,
        hierarchy: faker.helpers.arrayElement(['AGENCY_CHAIN']),
        companyType: faker.helpers.arrayElement([
          'AGENCY_CHAIN',
          'AGENCY',
          'POINT_OF_SALE',
        ]),
        modified: faker.date.recent().toISOString(),
        name: faker.lorem.words({ min: 2, max: 5 }),
        observation: faker.lorem.sentence(),
        policyId: Number(faker.string.numeric(4)),
        version: Number(faker.string.numeric(1)),
        defaultOn: index === 2 ? 'AGENCY_CHAIN' : undefined,
      }),
    )

    return HttpResponse.json({ data }, { status: 200 })
  },
)
